// One-shot ticket gating the Apple account-link step. sessionStorage (not in-memory like
// registerFlow) so it survives the IdP login round-trip; spent on entry, so it can't be reused.
const KEY = 'waipu.apple-link-intent';

export function setAppleLinkIntent(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // Storage unavailable (private mode / disabled): the guard then bounces, which is safe.
  }
}

/** Read-only: `beforeLoad` can run more than once per visit. */
export function hasAppleLinkIntent(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Spends the ticket, so a reload or a later deep-link bounces. */
export function clearAppleLinkIntent(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Storage unavailable: nothing to clear.
  }
}
